module.exports = __webpack_public_path__ + "static/media/blob-shape-2.542a6645.svg";